<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :tabs="tabs"
    :selectedIndex="selectedIndex"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    v-if="loaded"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Customer"
        :baseView="baseView"
        :primaryLabel="model.Name"
        :secondaryLabel="baseView.id"
        recordType="Customer"
      />
    </template>

    <div class="css-v2 grid-report" v-if="loaded">
      <gc-data-grid-report
        :exportFileName="report.exportFileName"
        :dataSourceConfig="report.dataSourceConfig"
        :columns="columns"
        :gridOptions="gridOptions"
        :persistenceKey="persistenceKey"
        :heightPadding="20"
      >
      </gc-data-grid-report>
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import CustomerTabsMixin from "@/_mixins/customer-tabs.mixin";
import GcDataGridReport from "@/components/gc-data-grid-report";
import { CustomerService } from "../../_services/api/customers/customer.service";

import { ScreenLayoutService } from "@/_services/api/reports/screen-layout.service";
import { CommonStorage } from "../../_services/storage";
import { getGlobalField } from "../../_store/helpers";
// import { DataGridState } from "../../_models/data-grid-state";

function logDev() {
  // eslint-disable-next-line no-console
  console.log("CX Log >>> ", arguments);
}

export default {
  props: {
    /**
     * contains report configurations
     */
    reportConfig: {
      type: Object,
      default: undefined,
    },
  },
  mixins: [RouteMixin, CustomerTabsMixin],
  components: {
    GcDataGridReport,
  },

  data() {
    return {
      // persistenceKey: "customer-transaction-history",
      backButtonRoute: `/customer`,
      model: {
        Code: "",
        Name: "",
      },
      report: {
        title: "",
        exportFileName: "",
        featureCode: "",
        dataSourceConfig: null,
        columns: [],
      },
      gridOptions: {
        noDataMessage: {
          addNew: {
            class: "no-data",
            title: "No Transactions",
            message:
              "Currently there are no transactions for this customer. Give them a call and sell them something today!",
          },
        },
      },
      loaded: false,
    };
  },
  computed: {
    reportDataSourceConfig() {
      return this.report.dataSourceConfig;
    },

    columns() {
      var cols = this.report.columns;

      return cols;
    },
  },
  mounted() {
    logDev("mounted ", this.columns);
  },

  async created() {
    CommonStorage.clear("go_back_route");
    this.selectedIndex = 6;
    let response = await ScreenLayoutService.getByRoute(
      "customer-transaction-history"
    );

    await CustomerService.getByCode(this.baseView.id, ["Code", "Name"]).then(
      async (response) => {
        if (response.data.value.length > 0) {
          this.model.Code = response.data.value[0].Code;
          this.model.Name = response.data.value[0].Name;
          // that.refreshView();
        }
      }
    );
    if (response.data.value) {
      var config = JSON.parse(response.data.value[0].Definition);
      var select = [];
      config.columns.forEach((e) => {
        if (!e.gridDataField && !e.dataField) {
          let globalField = getGlobalField(e.screenField);
          if (globalField.gridDataField) select.push(globalField.gridDataField);
          else if (globalField.dataField) select.push(globalField.dataField);
        } else {
          if (e.gridDataField) select.push(e.gridDataField);
          if (e.dataField) select.push(e.dataField);
        }
      });

      if (select.length > 0)
        config.dataSourceConfig.select = ["ICFlag"].concat(select);
      config.dataSourceConfig.filter = [["CustomerCode", "=", this.model.Code]];

      this.report = { ...config };
      logDev("report definition ", this.report);
    }

    this.loaded = true;
  },
  methods: {
    backButtonFunction() {
      this.$router.push({
        path: this.backButtonRoute,
      });
    },
    rowClickCallBack(e) {
      if (e.rowType == "data")
        if (
          e.data.CustomerTransactionType == "Credit" &&
          e.data.ICFlag == "C"
        ) {
          this.$router.push({
            path: `/credit-invoice/review/${e.data.CustomerTransactionNumber}`,
          });
        } else if (
          e.data.CustomerTransactionType == "Credit" &&
          e.data.ICFlag == "I"
        ) {
          this.$router.push({
            path: `/credit-customer/review/${e.data.CustomerTransactionNumber}`,
          });
        } else if (e.data.CustomerTransactionType == "Invoice") {
          this.$router.push({
            path: `/invoice/review/${e.data.CustomerTransactionNumber}`,
          });
        }
    },
  },
};
</script>
